import axios from "axios";
import { Base_URL } from "../url";

export const fetchEventsByOrg = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/EventDetails/GetEventsByOrg/${orgId}`,
    );

    return response.data;
  } catch (error) {
    console.error("Fetch Events Error:", error);
    throw error.response?.data || "Failed to fetch events";
  }
};

export const fetchEventByCode = async (orgId, eventCode) => {
  try {
    const response = await axios.get(
      `${Base_URL}/EventDetails/GetEventByCode/${orgId}/${eventCode}`,
    );

    return response.data;
  } catch (error) {
    console.error("Fetch Event Details Error:", error);
    throw error.response?.data || "Failed to fetch event details";
  }
};

export const fetchParticipantsByEvent = async (eventCode) => {
  try {
    const response = await axios.get(
      `${Base_URL}/EventDetails/GetParticipants/${eventCode}`,
    );

    return response.data;
  } catch (error) {
    console.error("Fetch Participants Error:", error);
    throw error.response?.data || "Failed to fetch participants";
  }
};

export const fetchRemindersByEvent = async (eventCode) => {
  try {
    const response = await axios.get(
      `${Base_URL}/EventDetails/GetReminders/${eventCode}`,
    );

    return response.data;
  } catch (error) {
    console.error("Fetch Reminders Error:", error);
    throw error.response?.data || "Failed to fetch reminders";
  }
};

export const fetchMoMByEvent = async (eventCode) => {
  try {
    const response = await axios.get(
      `${Base_URL}/EventDetails/GetMoM/${eventCode}`,
    );

    return response.data;
  } catch (error) {
    console.error("Fetch MoM Error:", error);
    throw error.response?.data || "Failed to fetch MoM";
  }
};

export const fetchEventsByProject = async (orgId, projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/EventDetails/GetEventsByProject/${orgId}/${projectId}`,
    );

    return response.data;
  } catch (error) {
    console.error("Fetch Project Events Error:", error);
    throw error.response?.data || "Failed to fetch project events";
  }
};

export const fetchEventDetails = async (eventCode) => {
  try {
    const response = await axios.get(
      `${Base_URL}/EventDetails/GetEventDetails/${eventCode}`,
    );

    return response.data;
  } catch (error) {
    console.error("Fetch Event Details Error:", error);
    throw error.response?.data || "Failed to fetch event details";
  }
};

// Add deleteEvent function to Api/ViewEvent.js
export const deleteEvent = async (orgId, eventCode, deletedBy) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/EventDetails/SoftDeleteEvent/${eventCode}`,
      {
        params: {
          orgId: orgId,
          deletedBy: deletedBy,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Delete Event Error:", error);
    throw error.response?.data || "Failed to delete event";
  }
};
